import { FC } from 'react';

interface TabProps {
  favicon?: string;
}

const Tab: FC<TabProps> = ({ favicon }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      fill="none"
      viewBox="0 0 702 32"
    >
      <g filter="url(#filter0_b_12669_80595)">
        <path fill="#565656" d="M0 0h702v32H0z" />
      </g>
      <g filter="url(#filter1_i_12669_80595)">
        <circle cx="19" cy="15" r="6" fill="#ED6A5E" />
      </g>
      <circle cx="19" cy="15" r="5.75" stroke="#CE5347" strokeWidth=".5" />
      <g filter="url(#filter2_i_12669_80595)">
        <circle cx="39" cy="15" r="6" fill="#F6BE4F" />
      </g>
      <circle cx="39" cy="15" r="5.75" stroke="#D6A243" strokeWidth=".5" />
      <g>
        <g filter="url(#filter3_i_12669_80595)">
          <circle cx="59" cy="15" r="6" fill="#62C554" />
        </g>
        <circle cx="59" cy="15" r="5.75" stroke="#58A942" strokeWidth=".5" />
      </g>
      <g>
        <path fill="#F9F9FA" d="M106 0h224v32H106z" />
        <path fill="#0A84FF" d="M106 0h224v1.5H106z" />
        <path
          fill="#0C0C0D"
          d="M138.972 20h4.834v-1.037h-3.631V12.25h-1.203V20zm6.832-6.875a.734.734 0 00.731-.725.73.73 0 00-1.461 0 .73.73 0 00.73.725zM145.219 20h1.16v-5.833h-1.16V20zm2.857 0h1.166v-3.421c0-.94.531-1.526 1.385-1.526s1.257.478 1.257 1.445V20h1.16v-3.776c0-1.391-.719-2.17-2.024-2.17-.849 0-1.408.376-1.692 1h-.086v-.887h-1.166V20zm6.65 0h1.165v-2.122l.5-.5L158.399 20h1.418l-2.594-3.373 2.433-2.46h-1.364l-2.315 2.46h-.086v-4.748h-1.165V20zm11.29.097c.816 0 1.455-.376 1.794-1.016h.091V20h1.16v-8.121h-1.16v3.212h-.091c-.312-.629-.994-1.026-1.794-1.026-1.483 0-2.417 1.165-2.417 3.013v.01c0 1.832.95 3.009 2.417 3.009zm.333-.994c-.978 0-1.563-.763-1.563-2.014v-.01c0-1.252.585-2.015 1.563-2.015.966 0 1.568.768 1.568 2.014v.01c0 1.247-.596 2.015-1.568 2.015zm6.896 1.01c1.493 0 2.299-.86 2.492-1.628l.011-.048-1.123.005-.021.043c-.14.301-.585.672-1.332.672-.961 0-1.574-.65-1.595-1.767h4.135v-.409c0-1.75-.999-2.927-2.626-2.927-1.627 0-2.68 1.22-2.68 3.04v.006c0 1.847 1.031 3.013 2.739 3.013zm-.054-5.103c.79 0 1.375.505 1.467 1.547h-2.965c.102-1.004.703-1.547 1.498-1.547zm7.015 6.934h1.166v-2.868h.086c.311.629.993 1.02 1.793 1.02 1.483 0 2.417-1.16 2.417-3.007v-.01c0-1.838-.945-3.014-2.417-3.014-.816 0-1.455.381-1.793 1.02h-.086v-.918h-1.166v7.777zm2.718-2.841c-.972 0-1.574-.768-1.574-2.014v-.01c0-1.247.602-2.015 1.574-2.015.972 0 1.557.757 1.557 2.014v.01c0 1.252-.585 2.015-1.557 2.015zm5.747.994c.773 0 1.386-.333 1.729-.924h.092V20h1.154v-3.99c0-1.225-.827-1.956-2.293-1.956-1.327 0-2.245.64-2.385 1.595l-.005.038h1.122l.006-.021c.139-.414.564-.65 1.208-.65.79 0 1.193.354 1.193.993v.516l-1.579.091c-1.392.086-2.176.693-2.176 1.735v.01c0 1.059.822 1.736 1.934 1.736zm-.774-1.784v-.01c0-.527.366-.817 1.171-.865l1.424-.091v.5c0 .751-.639 1.32-1.51 1.32-.628 0-1.085-.316-1.085-.854zm7.858 3.744c1.655 0 2.702-.848 2.702-2.175v-5.715h-1.16v.956h-.07c-.338-.655-.972-1.058-1.789-1.058-1.514 0-2.443 1.176-2.443 2.841v.011c0 1.643.923 2.798 2.422 2.798.8 0 1.445-.354 1.799-.988h.086v1.15c0 .794-.569 1.246-1.531 1.246-.789 0-1.262-.285-1.358-.688l-.006-.01h-1.176l-.011.01c.14.972 1.053 1.622 2.535 1.622zm-.016-3.303c-.993 0-1.552-.757-1.552-1.842V16.9c0-1.085.559-1.848 1.552-1.848.983 0 1.585.763 1.585 1.848v.01c0 1.091-.596 1.843-1.585 1.843zm6.865 1.359c1.708 0 2.755-1.144 2.755-3.024v-.01c0-1.88-1.053-3.025-2.755-3.025-1.708 0-2.761 1.15-2.761 3.024v.01c0 1.88 1.047 3.025 2.761 3.025zm0-.972c-1.005 0-1.569-.758-1.569-2.052v-.01c0-1.295.564-2.053 1.569-2.053.999 0 1.568.758 1.568 2.052v.01c0 1.29-.569 2.053-1.568 2.053z"
        />
        <path
          fill="#000"
          fillOpacity=".8"
          d="M315.019 15.991l3.78-3.78a.718.718 0 00-.507-1.21.717.717 0 00-.503.2l-3.78 3.78-3.781-3.78a.714.714 0 00-1.01 1.01l3.781 3.78-3.781 3.78a.71.71 0 00-.165.785.717.717 0 00.943.386.716.716 0 00.232-.16l3.781-3.78 3.78 3.78a.716.716 0 001.211-.508.71.71 0 00-.201-.502l-3.78-3.78z"
        />
        <g>
          <path
            fill="#fff"
            fillOpacity=".7"
            d="M352 15h-5v-5a.998.998 0 00-1-1 1 1 0 00-1 1v5h-5a1 1 0 100 2h5v5a.998.998 0 001 1 1 1 0 001-1v-5h5a1 1 0 100-2z"
          />
        </g>
      </g>
      <g>
        {favicon ? (
          <image transform="translate(108 4)" height={25} width={25} href={favicon}></image>
        ) : (
          <>
            <path
              fill="#1FD7AE"
              fillRule="evenodd"
              d="M124.234 24.688c-5.058 0-8.456-4.171-8.456-8.067 0-1.624.597-3.124 1.681-4.223 1.122-1.138 2.699-1.765 4.441-1.765a6.18 6.18 0 014.405 1.81c1.103 1.104 1.736 2.58 1.736 4.048h-1.194c0-2.272-1.988-4.706-4.947-4.706-2.855 0-4.928 2.034-4.928 4.836 0 2.9 2.524 6.915 7.262 6.915 5.028 0 7.371-4.23 7.371-7.088 0-2.122-.956-4.435-2.558-6.187-1.297-1.418-3.586-3.109-7.125-3.109-6.008 0-9.727 4.848-9.727 9.34H111C111 11.445 115.176 6 121.922 6c7.098 0 10.878 6.068 10.878 10.448 0 3.323-2.722 8.24-8.566 8.24"
              clipRule="evenodd"
            />
            <path
              fill="#1FD7AE"
              fillRule="evenodd"
              d="M124.078 27c-7.098 0-10.878-6.067-10.878-10.448 0-3.323 2.723-8.24 8.566-8.24 5.058 0 8.457 4.171 8.457 8.067 0 1.624-.598 3.124-1.682 4.224-1.122 1.138-2.699 1.765-4.441 1.765a6.18 6.18 0 01-4.405-1.811c-1.104-1.103-1.736-2.579-1.736-4.048h1.194c0 2.273 1.988 4.706 4.947 4.706 2.856 0 4.928-2.033 4.928-4.836 0-2.899-2.524-6.914-7.262-6.914-5.028 0-7.371 4.23-7.371 7.087 0 2.122.956 4.435 2.558 6.187 1.297 1.419 3.586 3.11 7.125 3.11 6.008 0 9.728-4.848 9.728-9.34H135C135 21.555 130.824 27 124.078 27"
              clipRule="evenodd"
            />
          </>
        )}
      </g>
      <defs>
        <filter
          id="filter0_b_12669_80595"
          width="742"
          height="72"
          x="-20"
          y="-20"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImage" stdDeviation="10" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_12669_80595"
          />
          <feBlend in="SourceGraphic" in2="effect1_backgroundBlur_12669_80595" result="shape" />
        </filter>
        <filter
          id="filter1_i_12669_80595"
          width="12"
          height="12"
          x="13"
          y="9"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="3" />
          <feComposite in2="hardAlpha" k2="-1" k3="1" operator="arithmetic" />
          <feColorMatrix values="0 0 0 0 0.92549 0 0 0 0 0.427451 0 0 0 0 0.384314 0 0 0 1 0" />
          <feBlend in2="shape" result="effect1_innerShadow_12669_80595" />
        </filter>
        <filter
          id="filter2_i_12669_80595"
          width="12"
          height="12"
          x="33"
          y="9"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="3" />
          <feComposite in2="hardAlpha" k2="-1" k3="1" operator="arithmetic" />
          <feColorMatrix values="0 0 0 0 0.960784 0 0 0 0 0.768627 0 0 0 0 0.317647 0 0 0 1 0" />
          <feBlend in2="shape" result="effect1_innerShadow_12669_80595" />
        </filter>
        <filter
          id="filter3_i_12669_80595"
          width="12"
          height="12"
          x="53"
          y="9"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="3" />
          <feComposite in2="hardAlpha" k2="-1" k3="1" operator="arithmetic" />
          <feColorMatrix values="0 0 0 0 0.407843 0 0 0 0 0.8 0 0 0 0 0.345098 0 0 0 1 0" />
          <feBlend in2="shape" result="effect1_innerShadow_12669_80595" />
        </filter>
      </defs>
    </svg>
  );
};

export default Tab;
